<template>
    <component v-bind="getParams" :is="htmlContent"></component>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-facing-decorator'
import ReselectScore from '../components/ReselectScore.vue'
import { Options } from '@/entities/conversation'
import { defaultCsatOptions } from '@/transforms/conversation'

// This component essentially acts as a container for taking care of the passed-through string that may or
// may not contain components we want to display; there were issues getting it to display on the main
// ConversationUIApp.  This gives us more control over their behaviour, but could definitely be improved.
@Component({
    emits: ['updatescore'],
})
export default class ConversationMessage extends Vue {
    @Prop({ type: String, default: '' }) public content!: string
    @Prop({ type: Boolean, default: false }) public interact!: boolean
    @Prop({ type: Array, default: () => defaultCsatOptions() })
    public csatLabels!: Options

    public get htmlContent() {
        return {
            components: {
                ReselectScore,
            },
            props: {
                interact: { type: Boolean, default: false },
                csatLabels: {
                    type: Array,
                    default: () => defaultCsatOptions(),
                },
            },
            methods: {
                updateScore(data): void {
                    // Ugly, but the compiler was throwing an error to complain that $emit doesn't exist on
                    // 'this', even though it does and the code worked.  Ideally would find a more conventional
                    // fix.
                    /* tslint:disable: no-string-literal */
                    this['$emit']('updatescore', data)
                    /* tslint:enable: no-string-literal */
                },
            },
            template: `<div>${this.content}</div>`,
        }
    }

    public get getParams() {
        return {
            interact: this.interact,
            csatLabels: this.csatLabels,
        }
    }
}
</script>

<style lang="less"></style>
